import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  ContentInfoQuery,
  ContentSaveResult,
} from '../content/common_pb';
import {
  DeltaPostInfo,
  PostInfo,
} from '../content/post_pb';

import {
  Post as __Post,
} from '../content/post_pb_service';

@Injectable({providedIn: 'root'})
export class Post {

  constructor(private _ngZone: NgZone) {
  }

  new(request: PostInfo): Promise<ContentSaveResult>;
  new(request: PostInfo, metadata: grpc.Metadata): Promise<ContentSaveResult>;
  new(request: PostInfo, callback: (err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void): void;
  new(request: PostInfo, metadata: grpc.Metadata, callback: (err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void): void;

  new(request: PostInfo, arg1?: grpc.Metadata|((err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void): Promise<ContentSaveResult>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<ContentSaveResult>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__Post.New, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  update(request: DeltaPostInfo): Promise<ContentSaveResult>;
  update(request: DeltaPostInfo, metadata: grpc.Metadata): Promise<ContentSaveResult>;
  update(request: DeltaPostInfo, callback: (err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void): void;
  update(request: DeltaPostInfo, metadata: grpc.Metadata, callback: (err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void): void;

  update(request: DeltaPostInfo, arg1?: grpc.Metadata|((err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: ContentSaveResult, metadata: grpc.Metadata) => void): Promise<ContentSaveResult>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<ContentSaveResult>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__Post.Update, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getInfo(request: ContentInfoQuery): Promise<PostInfo>;
  getInfo(request: ContentInfoQuery, metadata: grpc.Metadata): Promise<PostInfo>;
  getInfo(request: ContentInfoQuery, callback: (err: any|null, response: PostInfo, metadata: grpc.Metadata) => void): void;
  getInfo(request: ContentInfoQuery, metadata: grpc.Metadata, callback: (err: any|null, response: PostInfo, metadata: grpc.Metadata) => void): void;

  getInfo(request: ContentInfoQuery, arg1?: grpc.Metadata|((err: any|null, response: PostInfo, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: PostInfo, metadata: grpc.Metadata) => void): Promise<PostInfo>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<PostInfo>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__Post.GetInfo, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

